<template>
  <div>
    <b-modal
      id="modal-orders"
      centered
      title="Бронировать номер"
      ok-title="Заказать"
      cancel-title="Закрыть"
      cancel-variant="outline-secondary"
      size="sm"
      ref="vuemodal"
      @ok="acceptOrder"
      v-model="statusModal"
      @hide="keyboardHide"
      no-close-on-backdrop
    >
      <validation-observer
        ref="simpleRules"
      >
        <b-form @submit.stop.prevent="handleSubmit">
          <b-overlay
            :show="showOrderLoader"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            rounded="sm"
          >
            <b-row class="mb-1">
              <b-col cols="7" class="pr-0">
                <b-alert
                  variant="secondary"
                  show
                  class="w-100 h-100 alert-num-cat"
                >
                  <h1 class="alert-heading">{{ phoneNumber }}</h1>
                  <div class=" py-0 alert-body">
                    <p class="p-0">{{ category }}</p>
                  </div>
                </b-alert>
              </b-col>
              <b-col cols="5">
                <b-alert
                  variant="secondary"
                  show
                  class="w-100 h-100 alert-price"
                >
                  <div class="h-100 w-100 text-center d-flex align-items-center justify-content-center ">
                    <div>
                      <h1 class="w-100 d-block">
                        {{ price }}
                      </h1>
                      <p>
                        сомони
                      </p>
                    </div>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Фамилия, имя, отчество (в полном формате) *"
                  label-for="fio"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="ФИО"
                    rules="required"
                  >
                    <b-form-input
                      id="fio"
                      placeholder="Введите ФИО"
                      autocomplete="off"
                      v-model="fio"
                      :state="errors.length > 0 ? false:null"
                      data-layout="normal" @focus="showKeyboard"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="Номер, по которому можно связаться с Вами"
                  label-for="phoneNumber"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Номер телефона"
                    rules="required"
                  >
                    <b-form-input
                      type="number"
                      placeholder="Номер телефона"
                      autocomplete="off"
                      v-model="clientPhoneNumber"
                      data-layout="numeric" @focus="showKeyboard"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col v-if="!sensorActive" cols="12">
                <div class="d-flex w-100 mb-1">
                  <span class="w-75">
                  Заказать доставку SIM-карты
                  </span>
                  <span class="text-right w-25">
          <b-form-checkbox
            class="custom-control-success"
            name="check-button"
            switch
            v-model="deliveryStatus"
          >
        <span class="switch-icon-left">
          <feather-icon icon="TruckIcon"/>
        </span>
          <span class="switch-icon-right">
          <feather-icon icon="TruckIcon"/>
        </span>
        </b-form-checkbox>
        </span>
                </div>
                <b-collapse id="deliverySIM" class="w-100" v-model="deliveryStatus">
                  <b-form-group
                    label="Адрес доставки"
                    label-for="address"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Адрес доставки"
                      :rules="deliveryStatus ? 'required' : null"
                    >
                      <b-form-input id="address" placeholder="Вводите адрес доставки" autocomplete="off"
                                    v-model="address" data-layout="normal" @focus="showKeyboard"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-collapse>

              </b-col>

              <b-col v-if="!sensorActive" cols="12">
                <div class="d-flex mb-1">
            <span class="w-75">
        Онлайн регистрация
        </span>
                  <span class="text-right w-25">
          <b-form-checkbox
            class="custom-control-success"
            name="check-button"
            switch
            v-model="onlineRegStatus"
          >
        <span class="switch-icon-left">
          <feather-icon icon="UserPlusIcon"/>
        </span>
          <span class="switch-icon-right">
          <feather-icon icon="UserCheckIcon"/>
        </span>
        </b-form-checkbox>
        </span>
                </div>
                <b-collapse id="onlineReg" class="w-100" v-model="onlineRegStatus">
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Фото с паспортом"
                      :rules="onlineRegStatus ? 'required' : null"
                    >
                      <b-form-file
                        class="mb-1"
                        browse-text="Загрузить"
                        id="selfiePassport"
                        v-model="selfiePassport"
                        placeholder="Ваше фото с паспортом (Селфи)"
                        accept="image/*"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Паспорт (Строна А)"
                      :rules="onlineRegStatus ? 'required' : null"
                    >
                      <b-form-file
                        class="mb-1"
                        browse-text="Загрузить"
                        id="passportA"
                        v-model="passportA"
                        placeholder="Паспорт (Строна А)"
                        accept="image/*"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Паспорт (Строна B)"
                      :rules="onlineRegStatus ? 'required' : null"
                    >
                      <b-form-file
                        browse-text="Загрузить"
                        id="passportB"
                        v-model="passportB"
                        placeholder="Паспорт (Строна B)"
                        accept="image/*"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-collapse>
              </b-col>
              <b-col cols="12">
                <div class="pt-1 d-flex justify-content-center">
                  <VueRecaptcha ref="recaptcha" :sitekey="this.sitekey" :loadRecaptchaScript="true"
                                @verify="markRecaptchaAsVerified" @expired="onCaptchaExpired"/>
                </div>
                <p><small class="text-danger">{{ pleaseTickRecaptchaMessage }}</small></p>
              </b-col>
            </b-row>
          </b-overlay>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-modal
      ref="verifyModal"
      centered
      title="Верификация номер телефона"
      ok-title="Подвердить"
      cancel-title="Закрыть"
      cancel-variant="outline-secondary"
      size="sm"
      class="mb-5"
      @ok="verifyAndAcceptOrder"
      no-close-on-backdrop
    >
      <validation-observer
        ref="verifyRules"
      >
        <b-form @submit.stop.prevent="handleSubmitVerify">
          <b-overlay
            :show="showVerifyLoader"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            rounded="sm"
          >
            <b-col cols="12">
              <b-form-group
                label="Код подверждения"
                label-for="verifyCode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Код подверждения"
                  rules="required"
                >
                  <b-form-input
                    type="number"
                    placeholder="Код подверждения"
                    v-model="verifyCode"
                    data-layout="numeric" @focus="showKeyboard"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-overlay>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BForm,
  BFormInput,
  BFormCheckbox,
  BFormGroup,
  BFormFile,
  BCollapse,
  BAlert,
  BOverlay,
} from 'bootstrap-vue'
import ru from 'vee-validate/dist/locale/ru.json'
import VueRecaptcha from 'vue-recaptcha'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import VueCookies from 'vue-cookies'
import '@/@core/components/app-keyboard/vue-touch-keyboard/dist/vue-touch-keyboard.css' // load default style
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BModal,
    BForm,
    BFormInput,
    BFormCheckbox,
    BFormGroup,
    BFormFile,
    BCollapse,
    BAlert,
    BOverlay,
    VueRecaptcha,
  },
  data() {
    return {
      showOrderLoader: false,
      showVerifyLoader: false,
      deliveryStatus: false,
      onlineRegStatus: false,
      phoneNumber: '',
      category: '',
      price: '',
      fio: '',
      clientPhoneNumber: '',
      address: '',
      selfiePassport: null,
      passportA: null,
      passportB: null,
      verifyCode: '',
      sitekey: '6LfSmYcaAAAAAAd_8EeRyTZj_i9LXXDrAJ68eaXq',
      url: '',
      statusModal: false,
      fioState: null,
      submittedNames: [],
      required,
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      recaptchaToken: '',
      sensorActive: false,
    }
  },
  methods: {
    showModal(msisdn, category, price) {
      this.phoneNumber = msisdn
      this.category = category
      this.price = price
      this.clearInputs()
      this.$refs.vuemodal.show()
    },
    clearInputs() {
      this.deliveryStatus = false
      this.onlineRegStatus = false
      this.fio = ''
      this.clientPhoneNumber = ''
      this.address = ''
      this.selfiePassport = null
      this.passportA = null
      this.passportB = null
      this.verifyCode = ''
    },
    acceptOrder(ev) {
      ev.preventDefault()
      this.handleSubmit()
    },
    verifyAndAcceptOrder(ev) {
      ev.preventDefault()
      this.handleSubmitVerify()
    },
    validateModalForm() {
      const that = this

      that.$refs.simpleRules.validate().then(success => {
        if (!success) {
          return
        }
        if (!that.recaptchaVerified) {
          that.pleaseTickRecaptchaMessage = 'Пожалуйста, отметьте ReCaptcha.'
          return // prevent form from submitting
        }
        that.showOrderLoader = true
        const formData = new FormData()

        formData.append('clientPhoneNumber', this.clientPhoneNumber)
        formData.append('recaptchaToken', this.recaptchaToken)

        that.$http.post(`${this.url}/api/verify-code`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(response => {
            if (response.data === 1) {
              that.$refs.verifyModal.show()
              that.showOrderLoader = false
            }
          }).catch(() => {
            that.showOrderLoader = false
          })
      })
    },
    validateModalVerifyForm() {
      const that = this
      that.$refs.verifyRules.validate().then(success => {
        if (!success) {
          return
        }
        that.showVerifyLoader = true

        // this.$refs.verifyModal.show()
        const formData = new FormData()

        formData.append('msisdn', that.phoneNumber)
        formData.append('level', that.category)
        formData.append('fio', that.fio)
        formData.append('clientPhoneNumber', that.clientPhoneNumber)
        formData.append('verifyCode', that.verifyCode)
        if (that.deliveryStatus) {
          formData.append('address', that.address)
        }
        if (that.onlineRegStatus) {
          formData.append('selfiePassport', that.selfiePassport)
          formData.append('passportA', that.passportA)
          formData.append('passportB', that.passportB)
        }

        that.$http.post(`${that.url}/api/order`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            that.showVerifyLoader = false
            that.showOrderLoader = false

            if (response.data === 0) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Ошибка',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: 'Неверный код подтверждения.',
                },
              })
            } else {
              let myOrders = VueCookies.get('orders')
              const d = new Date()
              if (!myOrders || myOrders === '' || myOrders === null) {
                myOrders = {}
              }
              if (myOrders && myOrders[that.phoneNumber]) {
                delete myOrders[that.phoneNumber]
              } else {
                myOrders[that.phoneNumber] = {
                  level_name: this.category,
                  level_price: this.price,
                }
                myOrders[that.phoneNumber].msisdn = that.phoneNumber
                myOrders[that.phoneNumber].level = that.category
                myOrders[that.phoneNumber].fio = that.fio
                myOrders[that.phoneNumber].clientPhoneNumber = that.clientPhoneNumber
                myOrders[that.phoneNumber].dateAndTime = `${d.getDate()}.${(d.getMonth() + 1)}.${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
                if (that.deliveryStatus) {
                  myOrders[that.phoneNumber].address = that.address
                }
                if (that.onlineRegStatus) {
                  myOrders[that.phoneNumber].selfiePassport = that.selfiePassport
                  myOrders[that.phoneNumber].passportA = that.passportA
                  myOrders[that.phoneNumber].passportB = that.passportB
                }
              }
              VueCookies.set('orders', myOrders)
              that.$refs.vuemodal.hide()
              that.$refs.verifyModal.hide()
              that.$emit('close-modal', true)
            }
          }).catch()
      })
    },
    handleSubmit() {
      this.validateModalForm()
    },
    handleSubmitVerify() {
      this.validateModalVerifyForm()
    },
    validate() {
      this.$refs.recaptcha.execute()
    },
    markRecaptchaAsVerified(response) {
      this.recaptchaToken = response
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    showKeyboard(e) {
      this.$emit('keyboard-open', e)
    },
    keyboardHide() {
      this.$emit('keyboard-hide')
    },
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
    }
    this.url = 'https://tojtel.tj'
    localize('ru', ru)
  },
}
</script>

<style scoped>
.alert-secondary {
  background-color: #f7f6fc !important;
}

.alert p {
  font-weight: 400;
  color: #3a3746;
}

.alert-num-cat {
  /*border-top-right-radius: 0;*/
  /*border-bottom-right-radius: 0;*/
}

.alert-heading {
  color: #3a3746;
  font-size: 25px;
  box-shadow: none;
}

.alert-price {
  /*border-top-left-radius: 0;*/
  /*border-bottom-left-radius: 0;*/
}

.alert-price h1 {
  font-size: 30px;
  line-height: 25px;
}

modal-mb {
  margin-bottom: 150px;
}
</style>
